import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { HttpWrapperService } from '../http-wrapper/http-wrapper.service';
import { AuthResponse } from '../../../interfaces/http.interface';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private email: string = '';

    constructor(private readonly httpWrapperService: HttpWrapperService) {}

    login(ercToken: string): Observable<AuthResponse | null> {
        return this.httpWrapperService
            .post<AuthResponse>('/api/login', {
                session_token: ercToken
            })
            .pipe(map(({ body }: HttpResponse<AuthResponse>) => body));
    }

    setUserEmail(email: string): void {
        this.email = email;
    }

    getUserEmail(): string {
        return this.email;
    }
}
